module.exports = __webpack_public_path__ + "static/media/Helvetica Neue.0748e1a7.woff2";